"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FulfillmentLocationsListItem = _interopRequireDefault(require("./FulfillmentLocationsListItem"));

var _Alert = _interopRequireDefault(require("@cimpress/react-components/lib/Alert"));

var _TextField = _interopRequireDefault(require("@cimpress/react-components/lib/TextField"));

var _i18n = require("./i18n");

var _reactI18next = require("react-i18next");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var FulfillmentLocationsList =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FulfillmentLocationsList, _React$Component);

  function FulfillmentLocationsList(props) {
    var _this;

    _classCallCheck(this, FulfillmentLocationsList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FulfillmentLocationsList).call(this, props));
    _this.state = {
      searchNeedle: _this.props.searchString,
      pageToRender: 1
    };
    return _this;
  }

  _createClass(FulfillmentLocationsList, [{
    key: "isLocationMatching",
    value: function isLocationMatching(location) {
      if (!this.state.searchNeedle) {
        return true;
      }

      var searchFor = this.state.searchNeedle.toLowerCase();
      return location.FulfillerName.toLowerCase().indexOf(searchFor) !== -1 || location.FulfillmentLocationName.toLowerCase().indexOf(searchFor) !== -1 || (location.FulfillerId + '').indexOf(searchFor) !== -1 || (location.InternalFulfillerId + '').indexOf(searchFor) !== -1 || (location.FulfillmentLocationId + '').indexOf(searchFor) !== -1 || (location.InternalFulfillmentLocationId + '').indexOf(searchFor) !== -1;
    }
  }, {
    key: "onPageClicked",
    value: function onPageClicked(page) {
      this.setState({
        pageToRender: page
      });
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      if (!this.props.showHeader) {
        return null;
      }

      return _react.default.createElement("thead", null, _react.default.createElement("tr", {
        className: "cimpress-fl-list-header"
      }, _react.default.createElement("th", {
        style: {
          whiteSpace: "nowrap"
        }
      }, this.tt('name')), this.props.showFulfillmentLocationId ? _react.default.createElement("th", {
        style: {
          whiteSpace: "nowrap"
        }
      }, this.tt('location-id')) : null, this.props.showFulfillerId ? _react.default.createElement("th", {
        style: {
          whiteSpace: "nowrap"
        }
      }, this.tt('fulfiller-id')) : null, this.props.additionalColumnTitle ? _react.default.createElement("th", null, this.props.additionalColumnTitle) : null));
    }
  }, {
    key: "style",
    value: function style(styles) {
      if (this.props.disableInlineStyles) {
        return undefined;
      }

      return styles;
    }
  }, {
    key: "renderLocationsList",
    value: function renderLocationsList(locations, recentLocations) {
      var _this2 = this;

      var allLocations = recentLocations ? recentLocations.map(function (recentLocation) {
        return Object.assign({}, recentLocation, {
          IsRecent: true
        });
      }).concat(locations) : locations;
      var locationsToRender = allLocations;
      var paging = null;
      var length = recentLocations ? recentLocations.length + locations.length : locations.length;

      if (length >= this.props.maxItemsToShowAtOnce) {
        if (!this.props.showPartialResult) {
          // We cannot render "that many" locations
          return this.renderFilteringHelp(allLocations);
        } // Ok, we have too many... let's partially render


        var start = (this.state.pageToRender - 1) * this.props.maxItemsToShowAtOnce;
        locationsToRender = allLocations.slice(start, start + this.props.maxItemsToShowAtOnce);
        var hasPrev = start > 0;
        var hasNext = start + this.props.maxItemsToShowAtOnce < allLocations.length;

        if (hasPrev || hasNext) {
          var pages = Math.ceil(allLocations.length / this.props.maxItemsToShowAtOnce);
          var pageList = [];

          var _loop = function _loop(i) {
            var className = i == _this2.state.pageToRender ? "active" : undefined;
            pageList.push(_react.default.createElement("li", {
              key: i,
              className: className
            }, _react.default.createElement("a", {
              onClick: function onClick() {
                return _this2.onPageClicked(i);
              }
            }, i)));
          };

          for (var i = 1; i <= pages; i++) {
            _loop(i);
          }

          paging = _react.default.createElement("div", {
            className: "text-center"
          }, _react.default.createElement("ul", {
            className: "pagination pagination-sm",
            style: this.style({
              margin: "0px"
            })
          }, _react.default.createElement("li", {
            className: hasPrev ? undefined : "disabled"
          }, _react.default.createElement("a", {
            onClick: hasPrev ? function () {
              return _this2.onPageClicked(_this2.state.pageToRender - 1);
            } : undefined
          }, _react.default.createElement("i", {
            className: "fa fa-angle-left"
          }))), pageList, _react.default.createElement("li", {
            className: hasNext ? undefined : "disabled"
          }, _react.default.createElement("a", {
            onClick: hasNext ? function () {
              return _this2.onPageClicked(_this2.state.pageToRender + 1);
            } : undefined
          }, _react.default.createElement("i", {
            className: "fa fa-angle-right"
          })))));
        }
      }

      var renderedLocations = locationsToRender.map(function (location) {
        return _react.default.createElement(_FulfillmentLocationsListItem.default, {
          key: location.FulfillmentLocationId,
          location: location,
          highlight: _this2.props.enableSearchHighlighting ? _this2.state.searchNeedle : undefined,
          onClick: _this2.props.onSelectionClicked,
          disableInlineStyles: _this2.props.disableInlineStyles,
          showInternalIds: _this2.props.showInternalIds,
          showFulfillerId: _this2.props.showFulfillerId,
          showFulfillmentLocationId: _this2.props.showFulfillmentLocationId,
          additionalColumnRenderer: _this2.props.additionalColumnRenderer,
          customTitleRenderer: _this2.props.customTitleRenderer,
          isRecent: location.IsRecent
        });
      });
      return _react.default.createElement("div", null, this.props.showPartialResultPagingTop ? _react.default.createElement("div", {
        style: this.style({
          marginBottom: "18px"
        })
      }, paging) : null, _react.default.createElement("table", {
        className: "table table-hover cimpress-fl-list"
      }, this.renderHeader(), _react.default.createElement("tbody", null, renderedLocations)), this.props.showPartialResultPagingBottom ? paging : null);
    }
  }, {
    key: "_id",
    value: function _id(suffix) {
      var baseId = this.props.id ? this.props.id : 'locations-list';
      return "".concat(baseId, "-").concat(suffix);
    }
  }, {
    key: "tt",
    value: function tt(key) {
      var _this$props = this.props,
          t = _this$props.t,
          language = _this$props.language;
      return t(key, {
        lng: language
      });
    }
  }, {
    key: "renderFiltering",
    value: function renderFiltering() {
      var _this3 = this;

      if (!this.props.enableFiltering) {
        return null;
      }

      return _react.default.createElement(_TextField.default, {
        label: this.tt("search-label"),
        value: this.state.searchNeedle,
        onChange: function onChange(v) {
          return _this3.setState({
            searchNeedle: v.target.value,
            pageToRender: 1
          });
        },
        rightAddon: this.props.showCancelButton ? _react.default.createElement("button", {
          onClick: this.props.onCancelClicked,
          className: "btn btn-default"
        }, this.props.cancelButtonCaption ? this.props.cancelButtonCaption : this.tt('cancel')) : undefined
      });
    }
  }, {
    key: "renderFilteringHelp",
    value: function renderFilteringHelp(locations) {
      if (!this.props.enableFiltering) {
        return _react.default.createElement("div", {
          className: "list-group-item"
        }, _react.default.createElement(_Alert.default, {
          type: "info",
          message: "".concat(this.tt('too-many-locations-found'), " (").concat(locations.length, ")."),
          dismissible: false
        }));
      }

      return _react.default.createElement("div", {
        className: "list-group-item"
      }, _react.default.createElement(_Alert.default, {
        type: "info",
        message: "".concat(this.tt('too-many-locations-found'), " (").concat(locations.length, "). ").concat(this.tt('continue-typing-to-filter-more')),
        dismissible: false
      }), this.tt('searching-possible-by'), _react.default.createElement("ul", {
        style: this.style({
          paddingLeft: "inherit"
        })
      }, _react.default.createElement("li", null, this.tt('fulfiller-name')), _react.default.createElement("li", null, this.tt('fulfiller-id')), _react.default.createElement("li", null, this.tt('location-name')), _react.default.createElement("li", null, this.tt('location-id'))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var filteredLocations = this.props.enableFiltering ? this.props.fulfillmentLocations.filter(this.isLocationMatching.bind(this)) : this.props.fulfillmentLocations;

      if (this.props.recentFulfillmentLocations) {
        filteredLocations = filteredLocations.filter(function (location) {
          return _this4.props.recentFulfillmentLocations.filter(function (recent) {
            return recent.FulfillmentLocationId == location.FulfillmentLocationId;
          }).length <= 0;
        });
      }

      var filteredRecentLocations = this.props.recentFulfillmentLocations ? this.props.enableFiltering ? this.props.recentFulfillmentLocations.filter(this.isLocationMatching.bind(this)) : this.props.recentFulfillmentLocations : null;
      return _react.default.createElement("div", {
        id: this._id('list-wrapper')
      }, this.renderFiltering(), (!filteredLocations || filteredLocations.length == 0) && (!filteredRecentLocations || filteredRecentLocations.length == 0) ? _react.default.createElement(_Alert.default, {
        type: "warning",
        message: this.tt("no-locations-found"),
        dismissible: false
      }) : this.renderLocationsList(filteredLocations, filteredRecentLocations));
    }
  }]);

  return FulfillmentLocationsList;
}(_react.default.Component);

FulfillmentLocationsList.propTypes = {
  id: _propTypes.default.string,
  // locations
  fulfillmentLocations: _propTypes.default.array.isRequired,
  recentFulfillmentLocations: _propTypes.default.array,
  // functions and buttons
  onSelectionClicked: _propTypes.default.func,
  showCancelButton: _propTypes.default.bool,
  onCancelClicked: _propTypes.default.func,
  cancelButtonCaption: _propTypes.default.string,
  // search
  maxItemsToShowAtOnce: _propTypes.default.number,
  enableSearchHighlighting: _propTypes.default.bool,
  searchString: _propTypes.default.string,
  enableFiltering: _propTypes.default.bool,
  showPartialResult: _propTypes.default.bool,
  showPartialResultPagingTop: _propTypes.default.bool,
  showPartialResultPagingBottom: _propTypes.default.bool,
  // display
  showHeader: _propTypes.default.bool,
  disableInlineStyles: _propTypes.default.bool,
  showInternalIds: _propTypes.default.bool,
  showFulfillerId: _propTypes.default.bool,
  showFulfillmentLocationId: _propTypes.default.bool,
  // additional columns
  additionalColumnTitle: _propTypes.default.string,
  additionalColumnRenderer: _propTypes.default.any,
  customTitleRenderer: _propTypes.default.func,
  //
  language: _propTypes.default.string,
  // silence eslint
  t: _propTypes.default.any,
  i18n: _propTypes.default.any
};
FulfillmentLocationsList.defaultProps = {
  maxItemsToShowAtOnce: 50,
  enableSearchHighlighting: true,
  enableFiltering: true,
  showHeader: true,
  showPartialResult: false,
  showPartialResultPagingTop: false,
  showPartialResultPagingBottom: true,
  disableInlineStyles: false,
  showInternalIds: true,
  showFulfillerId: true,
  showFulfillmentLocationId: true,
  additionalColumnTitle: undefined,
  additionalColumnRenderer: undefined,
  showCancelButton: true,
  customTitleRenderer: undefined,
  language: 'eng'
};

var _default = (0, _reactI18next.translate)('translations', {
  i18n: (0, _i18n.getI18nInstance)()
})(FulfillmentLocationsList);

exports.default = _default;